import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Hero from "./Hero";
import MarqueeBand from "./MarqueeBand";
import Services from "./Services";
import Work from "./Work";
import Process from "./Process";
import Stats from "./Stats";
import Testimonials from "./Testimonials";
import Contact from "./Contact";
import Footer from "./Footer";
import { scrollToId } from "./SmoothScroll";
import useSeo from "../hooks/useSeo";

export default function Landing() {
  const loc = useLocation();

  useSeo({
    title: "IYM – Webdesign & Google Ads Agentur aus Dresden | Im Your Man",
    description:
      "IYM (Im Your Man) ist deine Agentur aus Dresden für Webdesign, Webentwicklung, Google Ads und SEO. Wir bauen Websites, die Kunden gewinnen – messbar und performant.",
    path: "/",
  });

  useEffect(() => {
    const id = loc.state && loc.state.scrollTo;
    if (id) {
      const t = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(t);
    }
  }, [loc.state]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <MarqueeBand />
        <Services />
        <Work />
        <Process />
        <Stats />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
